import { Controller } from "@hotwired/stimulus"

// Collapses the condo side menu (layouts/_condo_sidebar) to icons. The choice
// lives in localStorage and is applied by an inline script in the layout head
// before first paint, as <html data-sidebar="collapsed">.
export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.sync()
  }

  toggle() {
    const collapsed = !this.collapsed
    if (collapsed) {
      document.documentElement.setAttribute("data-sidebar", "collapsed")
    } else {
      document.documentElement.removeAttribute("data-sidebar")
    }
    try {
      localStorage.setItem("sidebar", collapsed ? "collapsed" : "expanded")
    } catch (e) {
      // private mode: the choice just won't persist
    }
    this.sync()
  }

  get collapsed() {
    return document.documentElement.getAttribute("data-sidebar") === "collapsed"
  }

  sync() {
    const label = this.collapsed ? "Expandir menú" : "Contraer menú"
    this.buttonTarget.setAttribute("aria-expanded", String(!this.collapsed))
    this.buttonTarget.setAttribute("aria-label", label)
    this.buttonTarget.setAttribute("title", label)
  }
}
